import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import Goods from '../views/goods/index.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	redirect: '/home'
}, 
{
	path: '/home',
	name: 'Home',
	component: Home
},
{
	path: '/goods',
	name: 'Goods',
	component: Goods
},
{
	path: '/outfits',
	name: 'Outfits',
	component: () => import('../views/home/model/home--type1/module/suit/index.vue')
},
{
	path: '/outfits--type5',
	name: 'Outfits',
	component: () => import('../views/home/model/home--type5/module/suit/index.vue')
},
{
	path: '/product-search-image',
	name: 'ImageSearch',
	component: () => import(/* webpackPrefetch: true */ '../views/imageSearch/index.vue')
}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 全局导航守卫，当路由发生改变时，将页面滚动到顶部
// iOS兼容：使用 requestAnimationFrame 延迟 + 判断是否需要滚动，避免触发 resize 循环
router.afterEach(() => {
	requestAnimationFrame(() => {
		// 只有当页面滚动位置大于 0 时才滚动，避免无谓的滚动触发 iOS 地址栏变化
		if (window.scrollY > 0) {
			window.scrollTo(0, 0);
		}
	});
});

export default router